// mailchimp handle

(function () {
  'use strict';

  /**
   * 邮箱验证函数
   * @param {string} email - 邮箱地址
   * @returns {boolean} 验证结果
   */
  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  /**
   * 邮编验证函数（支持5位数字或5位+4位格式）
   * @param {string} zipCode - 邮编
   * @returns {boolean} 验证结果
   */
  function validateZipCode(zipCode) {
    if (!zipCode || zipCode.trim() === '') {
      return false;
    }
    const zipRegex = /^\d{5}(-\d{4})?$/;
    return zipRegex.test(zipCode.trim());
  }

  /**
   * 获取错误消息的搜索容器（form 的父级 .evx-footer__signupRow）
   * @param {HTMLFormElement} form - 表单元素
   * @returns {Element} 搜索容器
   */
  function getErrorContainer(form) {
    return form.closest('.evx-footer__signupRow') || form;
  }

  /**
   * 清除错误状态
   * @param {HTMLFormElement} form - 表单元素
   */
  function clearErrors(form) {
    const container = getErrorContainer(form);

    // 移除成功状态，确保错误消息能正常显示
    const signupContainer = form.closest('.evx-footer__signup');
    if (signupContainer) {
      signupContainer.classList.remove('success');
    }

    const emailInput = /** @type {HTMLInputElement|null} */ (form.querySelector('input.email'));
    const zipCodeInput = /** @type {HTMLInputElement|null} */ (form.querySelector('input.zip-code'));
    const emailError = container.querySelector('.error-message.email-error');
    const zipCodeError = container.querySelector('.error-message.zip-code-error');

    if (emailInput) {
      emailInput.classList.remove('error');
    }
    if (zipCodeInput) {
      zipCodeInput.classList.remove('error');
    }
    if (emailError) {
      emailError.style.opacity = '0';
    }
    if (zipCodeError) {
      zipCodeError.style.opacity = '0';
    }
  }

  /**
   * 显示错误消息
   * @param {HTMLFormElement} form - 表单元素
   * @param {string} type - 错误类型（'email' 或 'zip-code'）
   * @param {string} message - 错误消息
   */
  function showError(form, type, message) {
    const container = getErrorContainer(form);
    const errorMessage = container.querySelector(`.error-message.${type}-error`);
    const input = form.querySelector(`input.${type}`);

    if (errorMessage) {
      if (message) {
        errorMessage.textContent = message;
      }
      errorMessage.style.opacity = '1';
    }
    if (input) {
      input.classList.add('error');
    }
  }

  /**
   * 构建 JSONP URL 并发起请求
   * @param {HTMLFormElement} form
   */
  function submitViaJsonp(form) {
    try {
      const action = form.getAttribute('action') || '';
      if (!action) return;

      // 解析 action，并确保使用 post-json 路径
      const url = new URL(action);
      if (!/post-json/.test(url.pathname)) {
        url.pathname = url.pathname.replace(/post$/, 'post-json');
      }

      // 收集表单字段（包括隐藏字段），排除禁用项
      const formData = new URLSearchParams(url.search);
      Array.from(form.elements).forEach(function (el) {
        const input = /** @type {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} */ (el);
        if (!input || !('name' in input)) return;
        if (!input.name || input.disabled) return;
        // 跳过未选中的复选框/单选框
        if ('type' in input && (input.type === 'checkbox' || input.type === 'radio')) {
          const checkbox = /** @type {HTMLInputElement} */ (input);
          if (!checkbox.checked) return;
        }
        formData.set(input.name, input.value);
      });

      // JSONP 回调
      const callbackName = 'mc_cb_' + Math.random().toString(36).slice(2);
      formData.set('c', callbackName);

      const script = document.createElement('script');
      const src = url.origin + url.pathname + '?' + formData.toString();

      /** @type {(res: {result: 'success'|'error', msg: string}) => void} */
      const mcCallback = function (res) {
        try {
          const modalContent = form.closest('.evx-footer__signup');
          if (res && res.result === 'success') {
            if (modalContent) {
              modalContent.classList.add('success');
            }
            // 清空输入
            form.reset();
          } else {
            // 将 Mailchimp 返回的信息展示在 email 错误区域
            const message = (res && res.msg) ? String(res.msg).replace(/<[^>]*>/g, '') : 'subscription failed';
            showError(form, 'email', message);
          }
        } finally {
          // 清理脚本与回调
          try { document.head.removeChild(script); } catch (_) { }
          try { delete /** @type {any} */ (window)[callbackName]; } catch (_) { }
        }
      };

      (/** @type {any} */ (window))[callbackName] = mcCallback;

      script.src = src;
      script.async = true;
      script.onerror = function () {
        showError(form, 'email', 'network error, please try again');
        try { document.head.removeChild(script); } catch (_) { }
        try { delete /** @type {any} */ (window)[callbackName]; } catch (_) { }
      };
      document.head.appendChild(script);
    } catch (_) {
      showError(form, 'email', 'unexpected error, please try again');
    }
  }

  // 初始化表单验证
  function initFormValidation() {
    const forms = document.querySelectorAll('.evx-footer__signup form');

    forms.forEach(function (formElement) {
      const form = formElement;
      const submitButton = form.querySelector('button[type="submit"]');

      if (!submitButton) {
        return;
      }

      // 定义点击处理函数
      /**
       * @param {Event} e - 点击事件
       */
      function handleClick(e) {
        // 清除之前的错误状态
        clearErrors(form);

        const emailInput = form.querySelector('input.email');
        const zipCodeInput = form.querySelector('input.zip-code');

        let isValid = true;

        // 验证邮箱
        if (emailInput) {
          const email = emailInput.value.trim();
          if (!email || !validateEmail(email)) {
            showError(form, 'email', 'invalid email address');
            isValid = false;
          }
        }

        // 验证邮编
        if (zipCodeInput) {
          const zipCode = zipCodeInput.value.trim();
          if (!zipCode || !validateZipCode(zipCode)) {
            showError(form, 'zip-code', 'invalid zip code');
            isValid = false;
          }
        }

        // 阻止默认提交；若通过则使用 JSONP 提交
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (isValid) {
          submitViaJsonp(form);
        }
      }

      // 使用 capture 阶段来确保优先执行
      submitButton.addEventListener('click', handleClick, true);

      // 额外拦截回车提交
      form.addEventListener('submit', function (e) {
        handleClick(e);
      }, true);

      // 当用户输入时清除对应的错误状态
      const emailInput = /** @type {HTMLInputElement|null} */ (form.querySelector('input.email'));
      const zipCodeInput = /** @type {HTMLInputElement|null} */ (form.querySelector('input.zip-code'));

      if (emailInput) {
        emailInput.addEventListener('input', function () {
          // 隐藏成功消息（如果正在显示）
          const signupContainer = form.closest('.evx-footer__signup');
          if (signupContainer && signupContainer.classList.contains('success')) {
            signupContainer.classList.remove('success');
          }

          if (this.classList.contains('error')) {
            this.classList.remove('error');
            const container = getErrorContainer(form);
            const emailError = container.querySelector('.error-message.email-error');
            if (emailError) {
              emailError.style.opacity = '0';
            }
          }
        });
      }

      if (zipCodeInput) {
        zipCodeInput.addEventListener('input', function () {
          // 隐藏成功消息（如果正在显示）
          const signupContainer = form.closest('.evx-footer__signup');
          if (signupContainer && signupContainer.classList.contains('success')) {
            signupContainer.classList.remove('success');
          }

          if (this.classList.contains('error')) {
            this.classList.remove('error');
            const container = getErrorContainer(form);
            const zipCodeError = container.querySelector('.error-message.zip-code-error');
            if (zipCodeError) {
              zipCodeError.style.opacity = '0';
            }
          }
        });
      }
    });
  }


  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFormValidation();
    });
  } else {
    initFormValidation();
  }
})();
